<template>
<div class="div0">
  <!--
  <div style="width:50%; height:100%;">
    <h1>Data table</h1>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :items-per-page="5"
      class="elevation-1 size7"
    ></v-data-table>
  </div>
  -->
    <v-img src="../assets/img/data-icon.png" @click="prepareData()" width="20px" class="cursorhand"> </v-img>
    Data
</div>
</template>

<script>

export default {
  name: 'DataTable',
  props: {indicatorSelObj: Object},
  components: {},
  data () {
    return {
      tlTree: {}
    }
  },
  methods: {
    processRow: function (row) {
        var finalVal = ''
        // console.log(row)
        for (var j = 0; j < row.length; j++) {
            var innerValue = (row[j] === null || row[j] === undefined) ? '' : row[j].toString()
            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString()
            }
            var result = innerValue.replace(/"/g, '""')
            if (result.search(/("|,|\n)/g) >= 0)
                result = '"' + result + '"'
            if (j > 0)
                finalVal += ','
            finalVal += result
        }
        // console.log(finalVal)
        return finalVal + '\n'
    },
    /*
    exportToCsv: function (filename, rows) {
      var csvFile = ''
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var mm = String(today.getMonth() + 1).padStart(2, '0') 
      var yyyy = today.getFullYear()
      today = mm + '/' + dd + '/' + yyyy
      csvFile += this.indicatorSelObj.Theme + '(' + this.indicatorSelObj.Unit + '),' + 'Source: ' + this.indicatorSelObj.Url, 'downloaded on ' + today 
      console.log(csvFile)

      for (var i = 0; i < rows.length; i++) {
        csvFile += this.processRow(rows[i])
      }
      var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' })
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a")
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob)
          link.setAttribute("href", url)
          link.setAttribute("download", filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    }, */
    /*
    refresh: function() {
      this.prepareData()
      this.$root.$once('component_refresh', () => {this.refresh()})
    },
    */
    prepareData: function () {
      let params = this.$route.params
      let tl = params.tl
      let tlToWalk = {}
      if (tl === "TL2") {
        tlToWalk = this.$store.getters.TL2
      }
      else if (tl === "TL3") {
        tlToWalk = this.$store.getters.TL3
      }
      else if (tl === "FUA") {
        tlToWalk = this.$store.getters.FUA
      }
      else if (tl === "EFUA") {
        tlToWalk = this.$store.getters.EFUA
      }
      else if (tl === "CY") {
        tlToWalk = this.$store.getters.CY
      }
      let country_id = this.$store.getters.countryID
      let ds = this.$store.getters.ds
      let years = this.$store.getters.years
      //console.log(ds)
      //console.log(years)
      //console.log(tlToWalk)
      this.$store.dispatch('setshow_overlay', true)
      // let yearSet = this.$store.getters.year.toString()
      this.tlTree = {}
      // let ds_data = null
      let code = ''
      let value = ''
      let arr_head = []
      arr_head.push('Code')
      arr_head.push('Country')
      arr_head.push('Name')
      for (let y of years) {
        // arr_head.push({text: y, value: y})
        arr_head.push(y)
      }
      let csvFile = ''

      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var mm = String(today.getMonth() + 1).padStart(2, '0') 
      var yyyy = today.getFullYear()
      today = dd + '/' + mm + '/' + yyyy

      let strUrl = ''
      if (this.indicatorSelObj.URL) {
        strUrl = this.indicatorSelObj.URL
        strUrl = strUrl.replace(/{Var}/,this.indicatorSelObj.Var)
      }
      if (this.indicatorSelObj.url) {
        strUrl = this.indicatorSelObj.url
        strUrl = strUrl.replace(/{tu}/,'')
        strUrl = strUrl.replace(/{year}/,'')
        let params = this.$route.params
        let tl = params.tl
        tl = tl.replace('TL', '')
        strUrl = strUrl.replace(/{tl}/,tl)
      }

      let strSource = this.indicatorSelObj.source

      let title = this.indicatorSelObj.Theme
      title = title.replace(/,/gi, ' ') 

      let unit = this.indicatorSelObj.Unit
      unit = unit.replace(/,/gi, ' ') 

      if (tl === "EFUA") {
        csvFile += title + ' (' + unit + '),Based on http://data.europa.eu/89h/347f0337-f2da-4592-87b3-e25975ec2c95,downloaded on ' + today  + '\n'
      }
      else {
        csvFile += title + ' (' + unit + '),Source: ' + strSource +  ',Data url:' + strUrl +  ',downloaded on ' + today  + '\n'
      }

      csvFile += this.processRow(arr_head)

      for (let t of tlToWalk) {
        // console.log(t)
        if (tl === "FUA" || tl === "CY" || tl === "EFUA") {
          code = t.id.toString()
        } else {
          code = t.code.toString()
        }
        let el = {}
        el['name'] = code
        /*
        arr_head.push( {
            text: 'TU',
            align: 'start',
            sortable: false,
            value: 'name',
          }
        )
        */
       // console.log(t)

        let arr = []
        arr.push(code)
        arr.push(t.country)        
        // arr.push(unescape(encodeURIComponent(t.name)))
        arr.push(t.name)

        for (let year of years) {
          if (this.selected != 1 || t.country == country_id ){
            value = ds.dataset[year][code]
            this.tlTree[code] = value
            el[year] = value
            arr.push(value)
          }
        }
        csvFile += this.processRow(arr)
      // arr.push(el)
      // this.desserts = arr
      // this.headers = arr_head
      }
      // console.log(csvFile)
      //console.log(this.$store.getters.indicatorsForCode)
      let key = params.indicod
      if (tl === "EFUA" || tl === 'FUA' || tl === 'CY') {
        key = tl + '-' + key
      } else {
        key = 'REG-' + key
      }
      //console.log(key)
      let filename = this.$store.getters.indicatorsForCode[key].Theme + '.csv'
      // let filename = 'pippoplutopaperino.csv'
      // let blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' })
      let blob = new Blob([csvFile], { type: 'text/csv;' })
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a")
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob)
          link.setAttribute("href", url)
          link.setAttribute("download", filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
      this.$store.dispatch('setshow_overlay', false)
      // console.log(arr)
      // console.log(this.tlTree)
    },
  },
  watch: {
    '$route' () {
    },
  },   
  mounted () {
    console.log("**** MOUNT DataTable ****")
    // this.$root.$once('component_refresh', () => {this.refresh()})
    // this.refresh()
  }
}
</script>
